var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFilter = function SvgIconFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1223 -778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1971.79,6528.5H-1989a1,1,0,0,1-1-1,1,1,0,0,1,1-1h17.209a2.5,2.5,0,0,1,2.291-1.5,2.5,2.5,0,0,1,2.293,1.5H-1965a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-2.206a2.5,2.5,0,0,1-2.293,1.5A2.5,2.5,0,0,1-1971.79,6528.5Zm-9.084-9.5H-1989a1,1,0,0,1-1-1,1,1,0,0,1,1-1h8.125a4,4,0,0,1,3.874-3,4,4,0,0,1,3.874,3H-1965a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-8.125a4,4,0,0,1-3.874,3A4,4,0,0,1-1980.874,6519Zm1.875-1a2,2,0,0,0,2,2,2,2,0,0,0,2-2,2,2,0,0,0-2-2A2,2,0,0,0-1979,6518Zm-7.793-8.5H-1989a1,1,0,0,1-1-1,1,1,0,0,1,1-1h2.208a2.5,2.5,0,0,1,2.293-1.5,2.5,2.5,0,0,1,2.291,1.5H-1965a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-17.208a2.5,2.5,0,0,1-2.291,1.5A2.5,2.5,0,0,1-1986.792,6509.5Z",
    transform: "translate(3220 -5720)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-filter.169d7ffd.svg";
export { ForwardRef as ReactComponent };